import { HealthCenter, UnitVisibilityOption } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getUnitsQuery } from './get-units-query';

export const getUnitsQueryOptions = (
  visibilityConfig: UnitVisibilityOption,
  healthCenter: HealthCenter | undefined,
  unitIds: string[]
) =>
  queryOptions({
    queryKey: healthCenter
      ? [
          getUnitsQuery(visibilityConfig, healthCenter, unitIds).className,
          getUnitsQuery(visibilityConfig, healthCenter, unitIds).toJSON(),
        ]
      : ['getUnits', 'disabled'],
    queryFn: async () => {
      if (!healthCenter) {
        return [];
      }
      const query = getUnitsQuery(visibilityConfig, healthCenter, unitIds);
      return await query.find();
    },
    enabled: !!healthCenter?.id,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
